export default class DomainMapping {

    mapData(domain) {
        return {
            id: domain ? domain.id : null,
            name_en: domain ? domain.name_en : null,
            name_fr: domain ? domain.name_fr : null,
            description_en: domain ? domain.description_en : null,
            description_fr: domain ? domain.description_fr : null,
            active: domain ? domain.active : true,
            position: domain ? domain.position : 0,
            color: domain ? domain.color : 'default',
        }
    }

    unmapData(data) {
        return data
    }
}
